import studentRequest from 'utils/studentRequest'
import instRequest from 'utils/instRequest'
import ErrorMessage from 'utils/ErrorMessage'
import authSelector from 'modules/Auth/selectors'

export const GET_TABLE = 'GET_TABLE'
export const GET_BATCH_HISTORY = 'GET_BATCH_HISTORY'

export const getPlacementData =
  (
    instituteCampusId,
    groupBy,
    educationType,
    domainId,
    degreeId,
    folderSearch
  ) =>
  async (dispatch, getState) => {
    try {
      let url = `/institutes/instituteCampus/${instituteCampusId}/courses/overView?groupBy=${groupBy}`

      if (educationType) {
        url += `&educationType=${educationType}`
      }
      if (domainId) {
        url += `&domainId=${domainId}`
      }
      if (degreeId) {
        url += `&degreeId=${degreeId}`
      }
      if (folderSearch) {
        url += `&search=${folderSearch}`
      }
      const result = await instRequest.get(url)
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getTableData =
  (instituteCampusId, payload) => async (dispatch, getState) => {
    try {
      let url = `/students/institutes/${instituteCampusId}/batch/list`
      const result = await studentRequest.post(url, payload)
      dispatch({ type: GET_TABLE, payload: result?.data })
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getPlacementStudent =
  (instituteCampusId, payload) => async (dispatch, getState) => {
    try {
      const result = await studentRequest.post(
        `/students/institutes/${instituteCampusId}/batch/list`,
        payload
      )
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getUserBatchHistory =
  instituteCampusId => async (dispatch, getState) => {
    const state = getState()
    const userId = authSelector.getUserId(state)

    try {
      const result = await instRequest.get(
        `institutes/${instituteCampusId}/batch/user/${userId}/history`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const updateUserBatchHistory =
  (instituteCampusId, payload) => async (dispatch, getState) => {
    const state = getState()
    const userId = authSelector.getUserId(state)
    payload.userId = userId
    try {
      const result = await instRequest.put(
        `institutes/${instituteCampusId}/batch/user/history`,
        payload
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getYear =
  (instituteCampusId, payload) => async (dispatch, getState) => {
    try {
      let {
        educationLevel = '',
        domainId = '',
        domain = '',
        degreeId = '',
        degree = '',
        streamId = '',
        stream = '',
      } = payload

      const queryParams = []
      if (educationLevel) queryParams.push(`educationLevel=${educationLevel.toLowerCase()}`)
      if (domainId) queryParams.push(`domainId=${domainId}`)
      if (domain) queryParams.push(`domain=${domain}`)
      if (degreeId) queryParams.push(`degreeId=${degreeId}`)
      if (degree) queryParams.push(`degree=${degree}`)
      if (streamId) queryParams.push(`streamId=${streamId}`)
      if (stream) queryParams.push(`stream=${stream}`)

      const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
      const result = await studentRequest.get(
        `/students/institutes/${instituteCampusId}/yearOfPassing${queryString}`
      )

      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getPreviewData = student_Id => async (dispatch, getState) => {
  try {
    const res = await studentRequest.get(`/students/${student_Id}`)
    return res?.data?.data
  } catch (error) {}
}

export const resumeBulkDownload = (payload) => async () => {
  try {
    const options = {}

    if (payload?.studentIds[0]?.length <= 5) {
      options.responseType = 'blob'
    }
    const response = await studentRequest.post(
      `/students/resume/bulkdownload`,
      payload,
      options
    )

    return response
  } catch (error) {
    console.error('Download error:', error)
    return { error }
  }
}

// New API for job roles bulk download
export const resumeBulkDownloadJobRoles = (payload) => async () => {
  try {
    const options = {}

    if (payload?.studentIds[0]?.length <= 5) {
      options.responseType = 'blob'
    }
    const response = await studentRequest.post(
      `/students/resume/bulkdownload/jobRoles`,
      payload,
      options
    )

    return response
  } catch (error) {
    console.error('Download error:', error)
    return { error }
  }
}